import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { OsobaSrodstvo } from './osoba-srodstvo';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-osoba-srodstvo-update',
    templateUrl: './osoba-srodstvo-update.component.html'
  })
  export class OsobaSrodstvoUpdateComponent
  extends BaseUpdateComponent<OsobaSrodstvo>
   implements OnInit {
  
    parameterList: List<QueryParameter> = List([]);
    ZaposleniID: QueryParameter = new QueryParameter();

    constructor(
      protected activatedRoute: ActivatedRoute,
      protected baseDataService: BaseDataService,
      // protected notificationsService: NotificationsService,
      protected toastrService: NotificationService,
      protected translateService: TranslateService
    
    ) { 
      super(activatedRoute, baseDataService, toastrService, translateService);
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.ZaposleniID.Value="-1";
      this.ZaposleniID.Name="zaposleniid";
      this.parameterList = this.parameterList.push(this.ZaposleniID);
    //   this.addValidatorToFc("Broj", Validators.required, 'required', 'OSOBATELEFON.BROJ.VALIDATION.REQUIRED');
    //   this.addValidatorToFc("Broj", Validators.maxLength(20), 'maxlength', 'OSOBATELEFON.BROJ.VALIDATION.MAXLENGTH');
      if (this.ParentProperty){  
        this.baseFormGroup.patchValue({OsobaID: this.ParentProperty.Value});
        this.baseFormGroup.get('OsobaID').disable();
      }

      this.IDProcessed
            .subscribe((value) => {
                if (value) {
                  this.ZaposleniID.Name="zaposleniid";
                    if (this.baseFormGroup.get('OsobaID').value){
                        this.ZaposleniID.Value=this.baseFormGroup.get('OsobaID').value;
                    }
                    else
                        this.ZaposleniID.Value=-1;
                    this.parameterList = this.parameterList.push(this.ZaposleniID);
                }
              })
    }

    onZaposleniSelect(value){
      if (value){
        //this.VrstaDokumentaID.Value=value;
       //let parameterList: List<QueryParameter> = List([new QueryParameter('VrstaDokumentaID', value)]);
       // let parameterList: List<QueryParameter> = List([new QueryParameter(this.VrstaDokumentaID.Value)]);
        this.parameterList=List([]);
        this.ZaposleniID.Name="zaposleniid";
        this.ZaposleniID.Value=value;
        this.parameterList = this.parameterList.push(this.ZaposleniID)
        this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
      }
    }
  
  }
  